export * from './invoice';
export * from './auth';
export * from './payment';
export * from './expense';

export const FILTER_LIST = [
  { value: 'Recent', label: 'Recent' },
  { value: 'Last_Week', label: 'Last week' },
  { value: 'Last_Month', label: 'Last month' },
  { value: 'Last_Quarter', label: 'Last Quarter' },
];

export const REPORT_LIST = [
  {value: "Invoice-Report", label: "Invoice-Report"},
  {value: "Expense-Report", label: "Expense-Report"},
  {value: "Customer-Report", label: "Customer-Report"},
  {value: "Inventory-Report", label: "Inventory-Report"},
]

export const CUSTOMER_LIST = [
  {value: "INV001", label: "INV001"},
  {value: "INV002", label: "INV002"},
  {value: "INV003", label: "INV003"}
]